/* PB kaching helpers v11 — idempotent DOM writes with current purchase state */
(function () {
  var GIFT = '<svg viewBox="0 0 16 16" width="12" height="12" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" style="flex:none"><rect x="2" y="6.2" width="12" height="7.6" rx="1.2"/><path d="M2 9.2h12M8 6.2v7.6M8 6.2c-1.6 0-3.1-.7-3.1-2 0-.9.7-1.6 1.6-1.6C7.7 2.6 8 4 8 6.2zm0 0c1.6 0 3.1-.7 3.1-2 0-.9-.7-1.6-1.6-1.6C8.3 2.6 8 4 8 6.2z"/></svg>';
  var tierDiscounts = {};
  function setAttr(el, name, value) { if (el.getAttribute(name) !== value) el.setAttribute(name, value); }
  function addClass(el, name) { if (!el.classList.contains(name)) el.classList.add(name); }
  function removeClass(el, name) { if (el.classList.contains(name)) el.classList.remove(name); }
  var bundleText = {};
  try { bundleText = JSON.parse(document.getElementById('pb-pg-vjson').textContent).bundleText || {}; } catch (_) {}
  function bt(key, values) {
    var text = bundleText[key] || key;
    Object.keys(values || {}).forEach(function (name) { text = text.replace('{' + name + '}', values[name]); });
    return text;
  }

  (function(){var S='.pb-pg__bundle-atc';function f(){var o=window.OCUApi;if(!o)return false;var c=o.excludeActionButton;if(!c)o.excludeActionButton=S;else if(String(c).indexOf(S)<0)o.excludeActionButton=c+','+S;return true}f();var n=0,t=setInterval(function(){if(f()||++n>150)clearInterval(t)},100);window.addEventListener('pointerdown',f,true);window.addEventListener('touchstart',f,{capture:true,passive:true})})();

  function markFree() {
    document.querySelectorAll('.kaching-bundles__bundle-products__pricing').forEach(function (pr) {
      var p = pr.querySelector('.kaching-bundles__bundle-products__price');
      if (!p) return;
      var digits = (p.textContent || '').replace(/[^0-9]/g, '');
      if (digits && parseInt(digits, 10) === 0) {
        addClass(pr, 'pbk-free');
        if (!pr.querySelector('.pbk-free-badge')) {
          var full = pr.querySelector('.kaching-bundles__bundle-products__full-price');
          var val = full ? (full.textContent || '').trim() : '';
          var b = document.createElement('span');
          b.className = 'pbk-free-badge';
          b.innerHTML = GIFT + '<span>' + bt('free') + '</span>';
          pr.appendChild(b);
          if (val) {
            var v = document.createElement('span');
            v.className = 'pbk-free-value';
            v.textContent = bt('value', {amount: val});
            pr.appendChild(v);
          }
        }
      } else {
        removeClass(pr, 'pbk-free');
        var ob = pr.querySelector('.pbk-free-badge'); if (ob) ob.remove();
        var ov = pr.querySelector('.pbk-free-value'); if (ov) ov.remove();
      }
    });
  }

  // Preserve app-owned money elements and comments when translating known defaults.
  function localizeDefault(selector, original, key) {
    document.querySelectorAll(selector).forEach(function (element) {
      if ((element.textContent || '').trim() !== original) return;
      var walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
      var node;
      while ((node = walker.nextNode())) {
        if (node.nodeValue.trim() !== original) continue;
        var next = node.nodeValue.replace(original, bt(key));
        if (node.nodeValue !== next) node.nodeValue = next;
      }
    });
  }

  function politeSubtitles() {
    // This winter offer includes a paid snowsuit; only the romper is free.
    document.querySelectorAll('.kaching-bundles__bar-subtitle').forEach(function (subtitle) {
      var walker = document.createTreeWalker(subtitle, NodeFilter.SHOW_TEXT);
      var node;
      while ((node = walker.nextNode())) {
        if (node.nodeValue.trim() === 'Snowsuit + romper as a gift') {
          node.nodeValue = node.nodeValue.replace('Snowsuit + romper as a gift', 'Romper free');
        }
      }
    });
    document.querySelectorAll('.kaching-bundles__upsell').forEach(function (upsell) {
      if (!bundleText.musical_offer || !upsell.querySelector('a[href*="/products/organic-cotton-musical-toy?"]')) return;
      var label = upsell.querySelector('.kaching-bundles__upsell__text');
      if (!label) return;
      var walker = document.createTreeWalker(label, NodeFilter.SHOW_TEXT);
      var node;
      while ((node = walker.nextNode())) {
        var source = node.nodeValue.trim();
        var offer = source.match(/^\+\s*Add Musical Toy\s*[—–]\s*save\s*(\d+(?:[.,]\d+)?)%$/i);
        if (!offer) continue;
        var next = node.nodeValue.replace(source, bt('musical_offer', {discount: offer[1]}));
        if (node.nodeValue !== next) node.nodeValue = next;
      }
    });
    // Translate only known Lullaby app copy, without replacing price nodes or controls.
    if (/^lt(?:-|$)/i.test(document.documentElement.lang) && /\/products\/(?:pb-lullaby-arch(?:-2-0)?|pb-moonveil(?:-grey|-white)?|pb-lullatone|perfectbaby(?:%E2%84%A2|™)-(?:felt-crib-mobile-|plush-animal-mobile-))/i.test(location.pathname)) {
      var lullabyCopy = {
        'COMPLETE YOUR LULLABY SET': 'SUSIKURKITE SAVO LULLABY RINKINĮ',
        'Complete Lullaby set': 'Visas Lullaby rinkinys',
        'Lullaby Arch only': 'Tik Lullaby laikiklis',
        'Just the arch': 'Tik laikiklis',
        'Just this mobile': 'Tik ši karuselė',
        'Change': 'Keisti',
        'BEST VALUE': 'GERIAUSIA VERTĖ'
      };
      document.querySelectorAll('.kaching-bundles__block-title, .kaching-bundles__bar-title, .kaching-bundles__bar-subtitle, .kaching-bundles__bar-most-popular, .kaching-bundles__collection-product').forEach(function (element) {
        var walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT), node;
        while ((node = walker.nextNode())) {
          var source = node.nodeValue, trimmed = source.trim(), next = source;
          if (lullabyCopy[trimmed]) next = source.replace(trimmed, lullabyCopy[trimmed]);
          next = next.replace('Arch + mobile + music box · You save', 'Laikiklis + karuselė + muzikos dėžutė · Sutaupote').replace('Mobile + arch + music box · You save', 'Karuselė + laikiklis + muzikos dėžutė · Sutaupote');
          if (next !== source) node.nodeValue = next;
        }
      });
    }
    localizeDefault('.kaching-bundles__block-title', 'BUNDLE & SAVE', 'bundle_save');
    localizeDefault('.kaching-bundles__block-title', 'Complete the winter set', 'complete');
    localizeDefault('.kaching-bundles__bar-subtitle', 'Standard price', 'standard_price');
    localizeDefault('.kaching-bundles__bar-most-popular', 'BEST VALUE', 'best_value');
    document.querySelectorAll('.kaching-bundles__bar-subtitle').forEach(function (s) {
      var walker = document.createTreeWalker(s, NodeFilter.SHOW_TEXT);
      var node;
      while ((node = walker.nextNode())) {
        var next = node.nodeValue.replace(/^(\s*)(?:You save|Save)(\s+)/i, function (_, space, gap) {
          return space + bt('save_prefix') + gap;
        });
        if (node.nodeValue !== next) node.nodeValue = next;
      }
    });
  }

  // Keep the numeric tier separate from its translated title across app re-renders.
  function tierCount(bar) {
    var title = bar.querySelector('.kaching-bundles__bar-title');
    if (!title) return 0;
    var text = (title.textContent || '').trim();
    var match = text.match(/^(\d+)\s*(?:pieces?|[- ]?item bundle)$/i);
    if (match) {
      if (bar.dataset.pbkTierCount !== match[1]) bar.dataset.pbkTierCount = match[1];
      return parseInt(match[1], 10);
    }
    var stored = parseInt(bar.dataset.pbkTierCount || '0', 10);
    return stored && text === bt('title', {count: stored}) ? stored : 0;
  }

  function clarifyTierTitles() {
    document.querySelectorAll('.kaching-bundles__bar').forEach(function (bar) {
      var count = tierCount(bar);
      var title = bar.querySelector('.kaching-bundles__bar-title');
      if (count && title.textContent !== bt('title', {count: count})) title.textContent = bt('title', {count: count});
    });
  }

  function explainTierOffers() {
    var bars = Array.prototype.slice.call(document.querySelectorAll('.kaching-bundles__bar'));
    var standardBar = bars.find(function (bar) {
      return bar.querySelector('.kaching-bundles__bar-title') && !tierCount(bar);
    });
    var standardPriceEl = standardBar ? standardBar.querySelector('.kaching-bundles__bar-price') : null;
    var standardPrice = parseMoney(standardPriceEl ? standardPriceEl.textContent : '');
    var offers = [];

    bars.forEach(function (bar) {
      var count = tierCount(bar);
      if (!count) {
        removeClass(bar, 'pbk-percentage-tier');
        return;
      }

      var priceEl = bar.querySelector('.kaching-bundles__bar-price');
      var price = parseMoney(priceEl ? priceEl.textContent : '');
      var key = bar.getAttribute('data-deal-bar-id') || count + '-item';
      var pct = tierDiscounts[key] || 0;
      if (!pct && standardPrice && price && standardPrice.val > 0) {
        var regular = standardPrice.val * count;
        pct = Math.round((regular - price.val) / regular * 100);
        if (pct > 0 && pct < 100) tierDiscounts[key] = pct;
      }
      if (!pct) return;

      if (bar.dataset.pbkDiscountPct !== String(pct)) bar.dataset.pbkDiscountPct = String(pct);
      addClass(bar, 'pbk-percentage-tier');
      var subtitle = bar.querySelector('.kaching-bundles__bar-subtitle');
      var offerText = bt('pick_any', {count: count}) + ' · ' + bt('off_each', {percent: pct});
      if (subtitle && subtitle.textContent.trim() !== offerText) subtitle.textContent = offerText;
      var appBadge = bar.querySelector('.kaching-bundles__bar-most-popular');
      if (appBadge) addClass(appBadge, 'pbk-app-badge--hidden');
      offers.push({ bar: bar, count: count, pct: pct });
    });

    var best = offers.reduce(function (winner, offer) {
      return !winner || offer.pct > winner.pct ? offer : winner;
    }, null);
    offers.forEach(function (offer) {
      var badge = offer.bar.querySelector('.pbk-tier-badge');
      if (best && offer.bar === best.bar) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'pbk-tier-badge';
          var container = offer.bar.querySelector('.kaching-bundles__bar-container') || offer.bar;
          container.appendChild(badge);
        }
        var badgeText = bt('best_value') + ' · ' + bt('off_each', {percent: offer.pct});
        if (badge.textContent !== badgeText) badge.textContent = badgeText;
      } else if (badge) {
        badge.remove();
      }
    });
    return best ? best.pct : 0;
  }

  function updateBundleTabBadge(maxTierPct) {
    var badge = document.querySelector('.pb-pg__tab-deal');
    if (!badge) return;
    var next = document.querySelector('.pbk-free-badge')
      ? bt('free_gift')
      : (maxTierPct ? bt('save_up', {percent: maxTierPct}) : bt('offers'));
    if (badge.textContent.trim() !== next) badge.textContent = next;
  }

  function localizeWidgetControls() {
    localizeDefault('.kaching-bundles__collection-product__choose-product-button, .kaching-bundles__choose-product__product-button', 'Choose', 'choose');
    localizeDefault('.kaching-bundles__choose-product__heading', 'Choose product', 'choose_product');
    var optionLabels = {
      'Color': 'color',
      'Colour': 'color',
      'Colors': 'color',
      'Colours': 'color',
      'Size': 'size',
      'Variants': 'variant',
      'Choose Your Frame Style': 'choose_frame',
      'Choose Your Toys': 'choose_toys'
    };
    Object.keys(optionLabels).forEach(function (name) {
      localizeDefault('.kaching-bundles__bar-variant-names span', name, optionLabels[name]);
    });
    document.querySelectorAll('.kaching-bundles__bar-variant-select').forEach(function (select) {
      var name = select.getAttribute('aria-label');
      var key = Object.prototype.hasOwnProperty.call(optionLabels, name) ? optionLabels[name] : '';
      if (key && name !== bt(key)) select.setAttribute('aria-label', bt(key));
      if ((key === 'size' || name === bt('size')) && bundleText.months_unit && bundleText.years_unit) {
        Array.prototype.forEach.call(select.options, function (option) {
          var original = option.textContent || '';
          if (!/^\s*\d[\d\s.,–—-]*\s+(?:months?|years?)\b/i.test(original)) return;
          var label = original.replace(/\bmonths?\b/gi, bundleText.months_unit).replace(/\byears?\b/gi, bundleText.years_unit);
          if (label !== original) option.textContent = label;
        });
      }
    });
    document.querySelectorAll('.kaching-bundles__collection-product__remove-button').forEach(function (button) {
      if (button.getAttribute('aria-label') === 'Remove product') button.setAttribute('aria-label', bt('remove'));
    });
    document.querySelectorAll('.kaching-bundles__choose-product__close img[alt="Close"]').forEach(function (image) {
      setAttr(image, 'alt', bt('close'));
    });
    var reviewLabels = [
      ['.jdgm-rev-widg__title', 'Customer Reviews', 'reviews'],
      ['.jdgm-rev-widg__summary-text', 'Be the first to write a review', 'no_reviews'],
      ['.jdgm-histogram__clear-filter', 'See all reviews', 'all_reviews'],
      ['.jdgm-write-rev-link', 'Write a review', 'write_review'],
      ['.jdgm-sort-dropdown-label', 'Sort by', 'sort'],
      ['.jdgm-sort-dropdown option', 'Most Recent', 'recent'],
      ['.jdgm-sort-dropdown option', 'Highest Rating', 'highest'],
      ['.jdgm-sort-dropdown option', 'Lowest Rating', 'lowest'],
      ['.jdgm-sort-dropdown option', 'Only Pictures', 'pictures_only'],
      ['.jdgm-sort-dropdown option', 'Pictures First', 'pictures_first'],
      ['.jdgm-sort-dropdown option', 'Videos First', 'videos_first'],
      ['.jdgm-sort-dropdown option', 'Most Helpful', 'helpful']
    ];
    reviewLabels.forEach(function (item) { localizeDefault(item[0], item[1], item[2]); });
    document.querySelectorAll('.jdgm-prev-badge__stars[aria-label], .jdgm-rev-widg__summary-stars[aria-label]').forEach(function (stars) {
      var label = stars.getAttribute('aria-label');
      var match = label.match(/^Average rating is ([\d.,]+) stars?$/);
      if (match) setAttr(stars, 'aria-label', bt('rating', {rating: match[1]}));
      else if (label === 'See all reviews') setAttr(stars, 'aria-label', bt('all_reviews'));
    });
    document.querySelectorAll('.jdgm-rev-widg__summary-average, .jdgm-rev-widg__summary-text').forEach(function (element) {
      var text = (element.textContent || '').trim();
      var average = text.match(/^([\d.,]+) out of 5$/);
      var count = text.match(/^Based on ([\d,]+) reviews?$/);
      if (average && element.textContent !== bt('average', {rating: average[1]})) element.textContent = bt('average', {rating: average[1]});
      if (count && element.textContent !== bt('based', {count: count[1]})) element.textContent = bt('based', {count: count[1]});
    });
  }

  function polishExternalWidgets() {
    document.querySelectorAll('[data-a11y-label="system.price"]').forEach(function (element) {
      setAttr(element, 'data-a11y-label', bt('price'));
    });
    document.querySelectorAll('[data-a11y-label="system.original_price"]').forEach(function (element) {
      setAttr(element, 'data-a11y-label', bt('original_price'));
    });

    var symbol = currencySymbol();
    document.querySelectorAll('.kaching-bundles .glc-money').forEach(function (money) {
      var text = (money.textContent || '').trim();
      if (symbol && /\d/.test(text) && !/[€$£¥]/.test(text)) { if (money.dataset.pbCurrency !== symbol) money.dataset.pbCurrency = symbol; }
      else if (money.hasAttribute('data-pb-currency')) money.removeAttribute('data-pb-currency');
    });

    document.querySelectorAll('.kaching-bundles__choose-product-modal').forEach(function (modal) {
      setAttr(modal, 'role', 'dialog');
      setAttr(modal, 'aria-modal', 'true');
      setAttr(modal, 'aria-label', bt('choose_product'));
    });

    // Omnisend offer copy is owned by the localized site-wide pb-customer-fixes.js.

  }

  function parseMoney(t) {
    var m = (t || '').replace(/\s/g, '').match(/([^0-9.,-]*)([\d.,]+)/);
    if (!m) return null;
    var num = m[2];
    var comma = num.indexOf(',') > -1 && num.lastIndexOf(',') > num.lastIndexOf('.');
    var val = parseFloat(comma ? num.replace(/\./g, '').replace(',', '.') : num.replace(/,/g, ''));
    if (isNaN(val)) return null;
    return { sym: m[1] || '', val: val, comma: comma };
  }

  function currencySymbol() {
    var samples = [
      document.querySelector('#pb-pg-cta-price'),
      document.querySelector('.price'),
      document.querySelector('[data-product-price]')
    ];
    for (var i = 0; i < samples.length; i++) {
      var txt = samples[i] ? (samples[i].textContent || '') : '';
      var match = txt.match(/[€$£¥]/);
      if (match) return match[0];
    }
    return '';
  }

  function displayMoney(t) {
    var clean = (t || '').trim();
    if (!clean || /[€$£¥]/.test(clean)) return clean;
    return currencySymbol() + clean;
  }

  function fmtMoney(v, ref) {
    var s = v.toFixed(2);
    if (ref.comma) s = s.replace('.', ',');
    return (ref.sym || currencySymbol()) + s;
  }

  function cleanProductName(t) {
    return (t || '')
      .replace(/PerfectBaby(?:™)?\s*/gi, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  // Kaching bar prices exclude optional checkbox upsells; include selected extras in our summary.
  function selectedUpsells(bar) {
    var extras = [];
    bar.querySelectorAll('.kaching-bundles__upsell').forEach(function (upsell) {
      if (!upsell.querySelector('.kaching-bundles__upsell__checkbox--selected')) return;
      var price = upsell.querySelector('.kaching-bundles__upsell__price');
      var full = upsell.querySelector('.kaching-bundles__upsell__full-price');
      var label = upsell.querySelector('.kaching-bundles__upsell__text');
      var amount = parseMoney(price ? price.textContent : '');
      if (!amount) return;
      var original = parseMoney(full ? full.textContent : '');
      extras.push({
        price: amount.val,
        original: original ? original.val : amount.val,
        name: upsell.querySelector('a[href*="/products/organic-cotton-musical-toy?"]') && bundleText.musical_toy
          ? bt('musical_toy') : cleanProductName(label ? label.textContent : '')
          .replace(/^\+\s*Add\s*/i, '').replace(/\s*[—–]\s*save.*$/i, '')
      });
    });
    return extras;
  }

  function selectedChoices(slot) {
    var choices = [];
    slot.querySelectorAll('select').forEach(function (select) {
      var option = select.options[select.selectedIndex];
      var label = option ? (option.textContent || '').trim() : '';
      if (option && option.value && label && !/^default title$/i.test(label) && choices.indexOf(label) === -1) choices.push(label);
    });
    return choices.join(' · ');
  }

  function getBundleMeta(bar) {
    if (!bar) return null;
    var titleEl = bar.querySelector('.kaching-bundles__bar-title');
    var rawTitle = titleEl ? (titleEl.textContent || '').trim() : '';
    var declared = rawTitle.match(/(\d+)\s*[- ]?\s*(?:pieces?|items?)/i);
    var declaredCount = tierCount(bar) || (declared ? parseInt(declared[1], 10) : 0);
    var names = [];
    var items = [];
    var collectionSlots = Array.prototype.slice.call(
      bar.querySelectorAll('.kaching-bundles__collection-product')
    );
    var fixedSlots = Array.prototype.slice.call(
      bar.querySelectorAll('.kaching-bundles__bundle-products__product')
    );
    var missing = 0;
    var hasGift = false;

    if (collectionSlots.length) {
      collectionSlots.forEach(function (slot) {
        var name = slot.querySelector('.kaching-bundles__collection-product__title');
        if (name && (name.textContent || '').trim()) {
          names.push(cleanProductName(name.textContent));
          items.push({ name: cleanProductName(name.textContent), choices: selectedChoices(slot), gift: false });
        } else {
          missing += 1;
        }
      });
    } else {
      fixedSlots.forEach(function (slot) {
        var name = slot.querySelector('.kaching-bundles__bundle-products__title');
        if (name && (name.textContent || '').trim()) {
          var cleanName = cleanProductName(name.textContent);
          var pricing = slot.querySelector('.kaching-bundles__bundle-products__pricing');
          var isGift = !!(pricing && pricing.classList.contains('pbk-free'));
          items.push({ name: cleanName, choices: selectedChoices(slot), gift: isGift });
          if (pricing && pricing.classList.contains('pbk-free')) {
            cleanName += ' (' + bt('free_gift') + ')';
            hasGift = true;
          }
          names.push(cleanName);
        }
      });
    }

    var extras = selectedUpsells(bar);
    extras.forEach(function (extra) {
      if (!extra.name) return;
      names.push(extra.name);
      items.push({ name: extra.name, choices: '', gift: false });
    });
    var count = (declaredCount || collectionSlots.length || fixedSlots.length || 1) + extras.length;
    var isBundle = count > 1 || collectionSlots.length > 1 || fixedSlots.length > 1;
    var itemsText = names.join(' + ');
    if (missing > 0) {
      itemsText += (itemsText ? ' + ' : '') + (missing === 1 ? bt('choose_one') : bt('choose_more', {count: missing}));
      items.push({ name: missing === 1 ? bt('choose_one') : bt('choose_more', {count: missing}), choices: '', gift: false });
    }
    if (!itemsText && isBundle) {
      itemsText = bt('included', {count: count});
      items.push({ name: itemsText, choices: '', gift: false });
    }

    return {
      count: count,
      extras: extras,
      isBundle: isBundle,
      missing: missing,
      discountPct: parseInt(bar.dataset.pbkDiscountPct || '0', 10) || 0,
      hasGift: hasGift,
      itemsText: itemsText,
      items: items,
      title: isBundle ? bt('title', {count: count}) : (rawTitle || bt('product'))
    };
  }

  function removeOldSummaries(keep) {
    document.querySelectorAll('.pbk-summary').forEach(function (box) {
      if (box !== keep) box.remove();
    });
  }

  function buildBundleCta() {
    var btn = document.querySelector('.pb-pg__bundle-atc');
    if (!btn) return;
    var track = btn.closest('.pbk-cta-track');
    if (!track) {
      track = document.createElement('div');
      track.className = 'pbk-cta-track';
      btn.parentNode.insertBefore(track, btn);
      var priceEl = document.createElement('span');
      priceEl.className = 'pbk-cta-price';
      track.appendChild(priceEl);
      track.appendChild(btn);
    }

    var selectedBar = document.querySelector('.kaching-bundles__bar--selected');
    if (!selectedBar) return;
    var selectedPrice = selectedBar.querySelector('.kaching-bundles__bar-price');
    var fullPrice = selectedBar.querySelector('.kaching-bundles__bar-full-price');
    var now = selectedPrice ? selectedPrice.textContent.trim() : '';
    var was = fullPrice ? fullPrice.textContent.trim() : '';
    var nowDisplay = displayMoney(now);
    var wasDisplay = displayMoney(was);
    var nowM = parseMoney(now);
    var wasM = parseMoney(was);
    var meta = getBundleMeta(selectedBar);
    if (!meta) return;
    if (nowM && meta.extras.length) {
      meta.extras.forEach(function (extra) {
        nowM.val += extra.price;
        if (wasM) wasM.val += extra.original;
      });
      now = nowDisplay = fmtMoney(nowM.val, nowM);
      if (wasM) was = wasDisplay = fmtMoney(wasM.val, wasM);
    }

    // Use the bundle's own reference price, matching checkout; do not add one item's compare-at gap.

    var save = 0;
    var pct = 0;
    var saveDisplay = '';
    if (meta.discountPct) {
      pct = meta.discountPct;
    } else if (nowM && wasM && wasM.val > nowM.val) {
      save = wasM.val - nowM.val;
      pct = Math.round(save / wasM.val * 100);
      saveDisplay = fmtMoney(save, nowM);
    }

    var pEl = track.querySelector('.pbk-cta-price');
    if (pEl && now) {
      var priceKey = meta.title + '|' + meta.discountPct + '|' + meta.hasGift + '|' + now + '|' + was + '|' + saveDisplay;
      if (pEl.dataset.v !== priceKey) {
        pEl.dataset.v = priceKey;
        pEl.innerHTML = '';
        var context = document.createElement('small');
        context.textContent = meta.isBundle
          ? meta.title + (meta.discountPct ? ' · ' + bt('off_each', {percent: meta.discountPct}) : (meta.hasGift ? ' · ' + bt('free_gift') : ''))
          : bt('product');
        var current = document.createElement('b');
        current.textContent = nowDisplay;
        pEl.appendChild(context);
        pEl.appendChild(current);
        if (meta.discountPct) {
          var tierSaving = document.createElement('em');
          tierSaving.textContent = bt('off_each', {percent: meta.discountPct});
          pEl.appendChild(tierSaving);
        } else if (saveDisplay) {
          var saving = document.createElement('em');
          saving.textContent = bt('save', {amount: saveDisplay, percent: pct});
          pEl.appendChild(saving);
        } else if (wasDisplay) {
          var original = document.createElement('s');
          original.textContent = wasDisplay;
          pEl.appendChild(original);
        }
      }
    }

    if (window.PBPurchase) window.PBPurchase.bundleMeta(meta);

    if (!meta.isBundle) {
      removeOldSummaries(null);
      return;
    }

    var box = document.querySelector('.pbk-summary');
    if (!box) {
      box = document.createElement('div');
      box.className = 'pbk-summary';
    }
    addClass(box, 'pbk-summary--inline');
    setAttr(box, 'role', 'status');
    setAttr(box, 'aria-live', 'polite');
    removeOldSummaries(box);

    var barMain = selectedBar.querySelector('.kaching-bundles__bar-main');
    if (barMain && box.previousElementSibling !== barMain) {
      barMain.insertAdjacentElement('afterend', box);
    }

    var summaryKey = [
      meta.title,
      meta.itemsText,
      JSON.stringify(meta.items),
      meta.missing,
      meta.discountPct,
      meta.hasGift,
      now,
      was,
      saveDisplay,
      pct
    ].join('|');
    if (box.dataset.v !== summaryKey) {
      box.dataset.v = summaryKey;
      box.innerHTML = '';

      var kicker = document.createElement('span');
      kicker.className = 'pbk-sum-kicker';
      kicker.textContent = meta.missing > 0
        ? bt('complete')
        : (meta.hasGift ? bt('with_gift') : bt('selected'));

      var items = document.createElement('ul');
      items.className = 'pbk-sum-items notranslate';
      items.setAttribute('translate', 'no');
      meta.items.forEach(function (item) {
        var row = document.createElement('li');
        row.className = 'pbk-sum-item';
        var name = document.createElement('span');
        name.className = 'pbk-sum-name';
        name.textContent = item.name;
        row.appendChild(name);
        if (item.gift) {
          var gift = document.createElement('span');
          gift.className = 'pbk-sum-gift';
          gift.textContent = bt('free_gift');
          name.appendChild(gift);
        }
        if (item.choices) {
          var choices = document.createElement('span');
          choices.className = 'pbk-sum-choices';
          choices.textContent = item.choices;
          row.appendChild(choices);
        }
        items.appendChild(row);
      });

      var facts = document.createElement('div');
      facts.className = 'pbk-sum-facts';

      var total = document.createElement('span');
      total.className = 'pbk-sum-total';
      total.textContent = bt('total', {count: meta.count, price: nowDisplay});
      facts.appendChild(total);

      if (meta.discountPct) {
        var tierSavings = document.createElement('span');
        tierSavings.className = 'pbk-sum-saving';
        tierSavings.textContent = bt('off_all', {percent: meta.discountPct, count: meta.count});
        facts.appendChild(tierSavings);
      } else if (saveDisplay) {
        var savings = document.createElement('span');
        savings.className = 'pbk-sum-saving';
        savings.textContent = bt('save', {amount: saveDisplay, percent: pct});
        facts.appendChild(savings);
      }

      box.appendChild(kicker);
      box.appendChild(items);
      box.appendChild(facts);
    }
  }

  function preserveProductNames() {
    document.querySelectorAll('.kaching-bundles__collection-product__title, .kaching-bundles__bundle-products__title, .pbk-sum-items').forEach(function (name) {
      setAttr(name, 'translate', 'no');
      addClass(name, 'notranslate');
    });
  }

  var timer;
  function run() {
    preserveProductNames();
    clearTimeout(timer);
    timer = setTimeout(function () {
      markFree();
      politeSubtitles();
      clarifyTierTitles();
      var maxTierPct = explainTierOffers();
      updateBundleTabBadge(maxTierPct);
      buildBundleCta();
      polishExternalWidgets();
      localizeWidgetControls();
    }, 120);
  }
  new MutationObserver(function (records) {
    var relevant = records.some(function (record) {
      if (record.type === 'childList') return true;
      var parent = record.target.parentElement;
      return record.type === 'characterData' && parent && parent.closest('.kaching-bundles__bar-subtitle');
    });
    if (relevant) run();
  }).observe(document.documentElement, { childList: true, characterData: true, subtree: true });
  document.addEventListener('change', function (event) {
    if (event.target.closest && event.target.closest('.kaching-bundles__bar')) run();
  });
  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);
})();



